import { baseClient, API } from "../index";

export const postKpiEvent = async (payload) => {
	return baseClient().post(`${API}/kpi/event`, payload);
};

